import validate from "/usr/src/app/content/n3-treatments-6b5cfd04-08c4-4332-9d61-f10cd215ab61/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-6b5cfd04-08c4-4332-9d61-f10cd215ab61/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}